import React from "react";
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB, nl } from "date-fns/locale";

function MyDatePicker(props) {
  const localeMap = {
    en: enGB,
    nl: nl,
  };
  const locale = localeMap[props.localeCode] || enGB;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
      <DatePicker
        type="date"
        disabled={props.disabled}
        value={props.value}
        maxDate={props.toDate}
        minDate={props.fromDate}
        inputFormat="dd/MM/yyyy"
        views={["day", "month", "year"]}
        onChange={(event) => {
          props.action(event);
        }}
        renderInput={(params) => (
          <TextField style={props.style} {...params} />
        )}
      />
    </LocalizationProvider>
  );
}
export default MyDatePicker;